import { FC } from "react";
import { LanguageService } from "../domain/services/LanguageService";
import languageServiceFactory from "../services/LanguageServiceImpl";
import { Langs } from "../domain/enums/common/LangsEnum";
import UkLangIconSVG from "./svg/flags-icons/UkLangIconSVG";
import UaLangIconSVG from "./svg/flags-icons/UaLangIconSVG";

interface CustomLangIconProps {
    lang?: string;
    className?: string;
}

const CustomLangIcon: FC<CustomLangIconProps> = (props) => {
    const langService: LanguageService = languageServiceFactory();
    switch (props.lang ? props.lang : langService.currentLang) {
        case Langs.EN:
            return <UkLangIconSVG className={props.className} />;
        case Langs.UA:
            return <UaLangIconSVG className={props.className} />;
        default:
            return <UaLangIconSVG className={props.className} />;
    }
};
export default CustomLangIcon;
